module.exports = __webpack_public_path__ + "static/song-of-solomon-0ba716fef57fce4a376d2647e7b1e57b.jpg";